<template>
	<div v-if="hidden == false" class="product-summary-bar">
		<div class="product-summary-bar__header">
			<div class="grid-container">
				<div class="grid-x grid-margin-x" style="justify-content: flex-end;">
					<div
						class="product-summary-bar__header-inner cell small-12 medium-shrink"
					>
						<span
							v-if="bookingType == 'skipass'"
							class="product-summary-bar__total"
						>
							{{ total }} × {{ $t('skipass.skipass') }}:
							<strong>{{ convertPrice(totalAmount) }} SEK</strong>
						</span>

						<span
							v-if="bookingType == 'skirental'"
							class="product-summary-bar__total"
						>
							{{ total }} × {{ $t('skirental.skirental') }}:
							<strong>{{ convertPrice(totalAmount) }} SEK</strong>
						</span>

						<span
							v-if="bookingType == 'skischool'"
							class="product-summary-bar__total"
						>
							{{ total }} × {{ $t('skischool.skischool') }}:
							<strong>{{ convertPrice(totalAmount) }} SEK</strong>
						</span>

						<span
							v-if="bookingType == 'activities'"
							class="product-summary-bar__total"
						>
							{{ total }} × {{ $t('activities.activities') }}:
							<strong>{{ convertPrice(totalAmount) }} SEK</strong>
						</span>

						<!-- <span v-else class="product-summary-bar__total">
							{{ $t('cart.total') }}:
							<strong>{{ convertPrice(totalAmount) }} SEK</strong>
						</span> -->

						<div class="product-summary-bar__buttons">
							<Button
								v-if="minimized == false"
								size="small"
								color="primary4"
								@click.native="toggleBar"
							>
								<span class="product-summary-bar__minimize">
									{{ $t('productSummaryBar.minimize') }}
								</span>
								<span
									class="product-summary-bar__minimize product-summary-bar__minimize--mobile"
								>
									<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'product-summary-bar__minimize-icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M21.19 4.22l-1.41-1.41L12 10.59 4.22 2.81 2.81 4.22 10.59 12l-7.78 7.78 1.41 1.41L12 13.41l7.78 7.78 1.41-1.41L13.41 12l7.78-7.78z"/></svg>
								</span>
							</Button>
							<Button
								v-if="minimized == true"
								size="small"
								color="primary4"
								@click.native="toggleBar"
							>
								<span class="product-summary-bar__maximize">
									{{ $t('productSummaryBar.maximize') }}
								</span>
								<span
									class="product-summary-bar__maximize product-summary-bar__maximize--mobile"
								>
									<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'product-summary-bar__minimize-icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M20.45 7.13L17.63 4.3a1 1 0 00-1.42 0L5 15.5a.88.88 0 00-.27.51L4 19.54a1 1 0 00.27.9 1 1 0 00.71.3h.2L8.75 20a1.1 1.1 0 00.51-.27L20.45 8.55a1 1 0 00.3-.71 1 1 0 00-.3-.71zM6.29 18.43L6.58 17a2.37 2.37 0 01.65.49 2.42 2.42 0 01.49.65zm2.29-.84a3.68 3.68 0 00-.61-.8 3.94 3.94 0 00-.8-.61L15 8.37l1.41 1.41zM17.13 9l-1.44-1.34 1.23-1.24 1.41 1.42z"/></svg>
								</span>
							</Button>
							<Button @click.native="addSkipassToCart" size="small">
								<span class="product-summary-bar__add">
									{{ $t('productSummaryBar.add') }}
								</span>
								<span
									class="product-summary-bar__add product-summary-bar__add--mobile"
								>
									<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'product-summary-bar__minimize-icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M22 2h-3a1 1 0 00-1 .82l-.39 2.1H3a1 1 0 00-.8.4 1 1 0 00-.2.88L4 13a1 1 0 00.88.72l12 1a1 1 0 01.8.26 1 1 0 01-.68 1.77H5a1 1 0 000 2h.55a2.09 2.09 0 000 .5 2.5 2.5 0 005 0 2.73 2.73 0 00-.05-.5h2.1a2.73 2.73 0 000 .5 2.5 2.5 0 104.94-.54 3 3 0 00.62-5.71l1.67-9H22a1 1 0 000-2zm-5.82 10.68l-10.41-.87-1.44-4.89h12.92zM8 20.75a1.5 1.5 0 01-1.5-1.5 1.72 1.72 0 01.11-.5 1.56 1.56 0 01.22-.4 1.77 1.77 0 01.31-.3 1.62 1.62 0 01.37-.19h.08a1.34 1.34 0 01.84 0h.08a1.62 1.62 0 01.37.19 1.77 1.77 0 01.31.3 1.56 1.56 0 01.22.4 1.43 1.43 0 01.09.5 1.5 1.5 0 01-1.5 1.5zm7 0a1.5 1.5 0 01-1.5-1.5 1.72 1.72 0 01.11-.5 1.56 1.56 0 01.22-.4 1.77 1.77 0 01.31-.3 1.62 1.62 0 01.37-.19h.08a1.34 1.34 0 01.84 0h.08a1.62 1.62 0 01.37.19 1.77 1.77 0 01.31.3 1.56 1.56 0 01.22.4 1.43 1.43 0 01.09.5 1.5 1.5 0 01-1.5 1.5z"/></svg>
									<span>{{ $t('accommodation.add') }}</span>
								</span>
							</Button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<transition-expand>
			<div
				v-if="minimized == false"
				class="product-summary-bar__details"
				id="test"
			>
				<div class="grid-container">
					<div class="grid-x grid-margin-x" style="justify-content: flex-end;">
						<div
							class="product-summary-bar__details-inner cell small-12 medium-shrink"
						>
							<ul class="product-summary-bar__list">
								<li v-for="product in selectedItems" :key="product.id">
									<span class="product-summary-bar__name">
										<strong>{{ product.value }} × {{ product.name }}</strong>
										{{ product.ageGroup }}
										<span v-if="product.displayLength">
											, {{ product.displayLength }}
										</span>
									</span>
									<span class="product-summary-bar__price">
										<strong>{{ convertPrice(product.price) }}</strong>
										SEK
									</span>
									<a
										class="product-summary-bar__remove"
										v-on:click="removeItem(product)"
									>
										<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M21.19 4.22l-1.41-1.41L12 10.59 4.22 2.81 2.81 4.22 10.59 12l-7.78 7.78 1.41 1.41L12 13.41l7.78 7.78 1.41-1.41L13.41 12l7.78-7.78z"/></svg>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</transition-expand>
	</div>
</template>

<script>
import store from '../../vueX/store'
import mixin from '../../mixin'

import Button from '../atoms/Button.vue'
import TransitionExpand from '../atoms/TransitionExpand'

export default {
	name: 'ProductSummaryBar',
	mixins: [mixin],
	components: {
		Button,
		TransitionExpand
	},
	props: {
		bookingType: {
			type: String,
			default: ''
		},
		productArray: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			hidden: false,
			minimized: true,
			summaryArray: this.productArray
		}
	},
	computed: {
		selectedItems() {
			return store.state.productList.selectedItems
		},
		total() {
			let productArrayClone = store.state.productList.selectedItems
			return productArrayClone.reduce((a, b) => a + parseInt(b.value), 0)
		},
		totalAmount() {
			let productArrayClone = store.state.productList.selectedItems
			return productArrayClone.reduce(
				(a, b) => a + parseInt(b.value) * b.price,
				0
			)
		}
	},
	methods: {
		toggleBar() {
			this.minimized = !this.minimized
		},
		removeItem(item) {
			store.dispatch('REMOVE_PRODUCT_SELECTED_ITEM', item)
		},
		addSkipassToCart() {
			this.$emit('on-add')
		}
	}
}
</script>

<style scoped lang="scss">
.product-summary-bar {
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	background: $colorPrimary6;
	z-index: 1029;

	&__header {
		background: $colorPrimary7;
		padding: 8px 0 15px;
		@media (min-width: 640px) {
			padding: 30px 0;
			&-inner {
				min-width: 600px;
			}
		}
		@include for-tablet-landscape-up {
			&-inner {
				min-width: 660px;
			}
		}
	}
	&__header-inner {
		display: flex;
		justify-content: space-between;
		@include for-tablet-portrait-up {
			display: block;
		}
	}

	&__details {
		overflow: hidden;
	}
	&__details-inner {
		padding: 0 0 10px;
		@include for-tablet-portrait-up {
			padding: 15px 0 80px;
		}
		@media (min-width: 640px) {
			min-width: 600px;
		}
		@include for-tablet-landscape-up {
			min-width: 660px;
		}
	}
	&__total {
		display: block;
		//width: 100%;
		font-size: 12px;
		font-weight: 300;
		color: $colorWhite;
		line-height: 24px;
		color: #d4d8df;
		strong {
			font-size: 24px;
			font-weight: 500;
			color: $colorWhite;
			display: block;
			font-size: 24px;
		}
		@include for-tablet-portrait-up {
			font-size: 22px;
			width: 100%;
			color: $colorWhite;
			margin-right: 30px;
			text-align: right;
			line-height: 40px;
			strong {
				font-size: 22px;
				display: inline;
			}
		}
		@media (min-width: 640px) {
			width: auto;
			float: left;
			font-size: 24px;
		}
		@include for-tablet-landscape-up {
			font-size: 28px;
		}
	}
	&__buttons {
		display: flex;
		//width: 100%;
		margin-top: 6px;
		text-align: right;
		@include for-tablet-portrait-up {
			display: block;
			width: 100%;
		}
		button:first-child {
			order: 2;
		}
		button {
			margin: 0 0 0 10px;
			@include for-phone-only {
				padding: 0 12px 0 12px;
			}
		}
		@media (min-width: 640px) {
			width: auto;
			float: right;
			margin-top: 0;
		}
	}
	&__minimize,
	&__maximize,
	&__add {
		display: none;
		@include for-tablet-portrait-up {
			display: block;
		}
		&--mobile {
			display: block;
			display: flex;
			@include for-tablet-portrait-up {
				display: none;
			}
			> span {
				margin: 0 8px;
				font-size: 16px;
				font-weight: 500;
				letter-spacing: 0;
				line-height: 20px;
			}
		}
	}
	/*&__maximize{
		&--mobile{

		}
	}*/
	&__minimize-icon {
		width: 20px;
		height: 20px;
		fill: #ffffff;
	}

	&__list {
		color: $colorWhite;
		font-size: 14px;
		line-height: 1;
		padding: 10px 0;
		li {
			display: flex;
			align-items: center;
			border-bottom: 1px solid $colorPrimary4;
			padding: 15px 0;
		}
		strong {
			font-weight: 500;
		}
		@include for-tablet-portrait-up {
			font-size: 18px;
		}
	}
	&__name {
		margin-right: auto;
	}
	// &__price {
	// }
	&__remove {
		width: 18px;
		height: 18px;
		cursor: pointer;
		margin-left: 20px;
		svg {
			width: 18px;
			height: 18px;
			fill: $colorWhite;
		}
		&:hover {
			svg {
				fill: #ccc;
			}
		}
		@include for-tablet-portrait-up {
			margin-left: 45px;
		}
	}
}
</style>
